const ActionType = {
  CLEAR_SUBMITTED: 'common/clear-submitted',
  SAVE_FIELD_VALIDATION_ERROR: 'common/save-field-validation-error',
  CLEAR_FIELD_VALIDATION_ERROR: 'common/clear-field-validation-error',
}

export default ActionType
